<template>
	<div class="">
		<el-form :model="form" label-width="50px" size="mini">
			<el-form-item label="表单">
				<el-select v-model="form.controller" placeholder="" filterable>
					<el-option v-for="item in tableData" :label="item.controller + '{'+item.name+'}'" :value="item.route" :key="item.id"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
	</div>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			node: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				form: {
					controller: null,
					type:'system'
				},
				count: 0,
				tableData:[]
			}
		},
		created() {
			this.$api.module.list().then((res)=>{
				
				this.tableData = res.list.filter((item)=>{
					return item.route && item.controller
				})
			})
		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},

		methods: {
			submit() {
				this.tableData.forEach((item)=>{
					if(item.route == this.form.controller){
						this.form.type = item.type
					}
				})
				return this.form
				// this.edge.replaceData(this.form)
				// this.edge.appendLabel(this.form.component)
			}
		},
		components: {

		}
	}
</script>
